export const newTrigramsMap = new Map([
    ['NACamDoorTag', 'DTG'],
    ['NACamera', 'NSC'],
    ['NAMain', 'NWS'],
    ['NAModule1', 'NOM'],
    ['NAModule2', 'NWA'],
    ['NAModule3', 'NRG'],
    ['NAModule4', 'NIM'],
    ['NAPlug', 'TPG'],
    ['NATherm1', 'THM'],
]);